import http from "../../core/services/http.service";

const BiddersService = {
  getBidders(params = null, expand = '') {
    return http.get(`/api/v1/bidders/?expand=${expand}`, {params});
  },
  getBidder(saleNo, paddleNumber, expand, params) {
    return http.get(`/api/v1/auctions/${saleNo}/bidders/${paddleNumber}/?expand=${expand}`, {params});
  },
  createBidder(data, expand = '') {
    return http.post(`/api/v1/bidders/?expand=${expand}`, data);
  },
  updateBidder(id, data, expand = '') {
    return http.put(`/api/v1/bidders/${id}/?expand=${expand}`, data);
  },
  removeBidder(uuid) {
    return http.delete(`/api/v1/bidders/${uuid}`)
  },
  partialUpdateBidder(id, data){
    return http.patch(`/api/v1/bidders/${id}/`, data);
  },
  batchPrintPaddleNumbers(data) {
    return http.put(`/api/v1/bidders/batch/print-paddle-numbers/`, data);
  },
  getLatestPaddleNumber(auctionUuid) {
    return http.get(`/api/v1/auctions/${auctionUuid}/latest-paddle-number/`);
  },
};

export default BiddersService;
